'use strict';

import GenericTableData from './GenericTableData';

// LineItemResource Module Event Bus.
let LineItemResourceData = GenericTableData.getTableDataBus(
  'LIR',
  'line_item_resources',
);

export default LineItemResourceData;
